import { render, staticRenderFns } from "./TrTextAreaOnBackground.vue?vue&type=template&id=b1a42e54&scoped=true&"
import script from "./TrTextAreaOnBackground.vue?vue&type=script&lang=js&"
export * from "./TrTextAreaOnBackground.vue?vue&type=script&lang=js&"
import style0 from "./TrTextAreaOnBackground.vue?vue&type=style&index=0&id=b1a42e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a42e54",
  null
  
)

export default component.exports